import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { DELEGATE_FIELD_KEYS } from 'pages/AnnualUserAccessReview/views/Delegate/_config';

/**
 * User selection for start and end dates for delegation privliges
 * @param {Object} formik form state
 * @returns start/end date form fields
 */
const SelectDates = ({ formik }) => {
	const startDateHasErrors =
		DELEGATE_FIELD_KEYS.START_DATE in formik?.touched &&
		DELEGATE_FIELD_KEYS.START_DATE in formik?.errors;
	const endDateHasErrors =
		DELEGATE_FIELD_KEYS.END_DATE in formik?.touched &&
		DELEGATE_FIELD_KEYS.END_DATE in formik?.errors;
	return (
		<Stack
			id='stack-123'
			direction={'column'}
			alignItems={'center'}
			justifyContent={'center'}
			spacing={4}
		>
			<FormControl
				variant='filled'
				// sx={{ mt: 2, width: '100%' }}
				sx={{ width: { sm: '100%', lg: '50%' } }}
			>
				<TextField
					variant='outlined'
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					value={formik.values[DELEGATE_FIELD_KEYS.START_DATE]}
					name={DELEGATE_FIELD_KEYS.START_DATE}
					type='date'
					label='Date to start delegation'
					error={startDateHasErrors}
					helperText={
						startDateHasErrors
							? formik.errors[DELEGATE_FIELD_KEYS.START_DATE]
							: 'This date can be no more than one year from the end of the current month.'
					}
					focused
					sx={{ mb: '2rem' }}
				/>
				<TextField
					variant='outlined'
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					value={formik.values[DELEGATE_FIELD_KEYS.END_DATE]}
					name={DELEGATE_FIELD_KEYS.END_DATE}
					type='date'
					label='Date to end delegation'
					error={endDateHasErrors}
					helperText={
						endDateHasErrors
							? formik.errors[DELEGATE_FIELD_KEYS.END_DATE]
							: 'This date can be no more than one year from the end of the current month.'
					}
					focused
				/>
			</FormControl>
		</Stack>
	);
};

export default SelectDates;
